export const RETURN_STEPS = {
  SELECT_ITEMS: 0,
  REFUND_METHOD: 1,
  RETURN_SUMMARY: 2,
  PRE_PRINTED_SLIP: 3,
  RETURN_SUBMITTED: 4,
}

export default { RETURN_STEPS }
